function getZacetekZavarovanjaPrvaDiagnoza202204(
    datumSklenitve
) {
    if (datumSklenitve.getDate() > 25) {
        return new Date(
            datumSklenitve.getFullYear(), 
            datumSklenitve.getMonth() + 2, 
            1,
        );    
    }

    return new Date(
        datumSklenitve.getFullYear(), 
        datumSklenitve.getMonth()+1, 
        1,
    );
};

module.exports = {
    getZacetekZavarovanjaPrvaDiagnoza202204,
}